import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  PerformStockCountRootParamList,
  StockCountItemHistoryRootScreenParamList,
  StockCountsRootParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { StockCountItemHistoryScreen } from "../StockCountItemHistoryScreen";
import { EditProductRootScreen } from "../../../products/screens";
import React from "react";
import { useStockCountScreenContextProvider } from "../StockCountScreen/hooks";
import StockCountLine from "../../../../utilities/data/model/StockCountLine";
import { SelectedStockCountItemContext } from "../../utils/count-stock/context";

export type StockCountItemHistoryRootScreenProps = StackScreenProps<
  PerformStockCountRootParamList,
  "StockCountItemHistoryRootScreen"
>;

export const StockCountItemHistoryRootScreen = ({
  navigation,
  route,
}: StockCountItemHistoryRootScreenProps) => {
  const { stockCount } = useStockCountScreenContextProvider();
  const [stockCountItem, setStockCountItem] = React.useState<
    StockCountLine | undefined
  >(undefined);

  React.useEffect(() => {
    (async () => {
      const stockItem = await stockCount.getChildItemById(
        route.params.stockCountLineId
      );
      if (stockItem) {
        setStockCountItem(stockItem);
      }
    })();
  });

  React.useEffect(() => {
    if (stockCountItem) {
      navigation.setOptions({
        headerShown: false,
      });
    }
  }, [stockCountItem?.id]);

  const Stack =
    createStackHeaderNavigator<StockCountItemHistoryRootScreenParamList>();

  if (!stockCountItem) {
    return;
  }

  return (
    <SelectedStockCountItemContext.Provider
      value={{
        stockCountLineItem: stockCountItem,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          headerLeft: () => <ModalCloseButton type="Close" />,
          title: "",
        }}
      >
        <Stack.Group>
          <Stack.Screen
            name="StockCountItemHistoryScreen"
            component={StockCountItemHistoryScreen}
          />
        </Stack.Group>
        <Stack.Group
          screenOptions={{
            presentation: "modal",
            headerShown: false,
            cardStyleInterpolator: CardStyleInterpolators.forVerticalIOS,
            headerLeft: () => <ModalCloseButton type="Close" />,
          }}
        >
          <Stack.Screen
            name="EditProductRootScreen"
            component={EditProductRootScreen}
            options={{
              headerShown: false,
            }}
          />
        </Stack.Group>
      </Stack.Navigator>
    </SelectedStockCountItemContext.Provider>
  );
};
